import axios from 'axios';
import { Dispatch, FormEvent, SetStateAction, useState } from 'react';

import {
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../../styles/GlobalComponents';

import Spinner from '../../../components/common/Spinner';

import { P1, P2, P3 } from '../../../styles/FontStyles';

import ReactCodeInput from 'react-code-input';
import { color } from '../../../styles/GlobalStyles';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  ErrorToast,
  SuccessToast
} from '../../../components/common/Toasts/Toasts';
import {
  confirmBonusHubgNFTWithdraw,
  confirmNFTWithdraw
} from '../Portfolio.actions';

interface TwoFASetupProps {
  setWithdrawStep: Dispatch<SetStateAction<number>>;
  walletAddress: string | undefined;
  setWalletAddress: Dispatch<SetStateAction<any>>;
  packageId: number;
  code: string;
  code2Fa: string;
  setCode: Dispatch<SetStateAction<string>>;
  setCode2Fa: Dispatch<SetStateAction<string>>;
  walletAddressSign: string;
}

export const Step3 = ({
  setWithdrawStep,
  packageId,
  walletAddress,
  walletAddressSign,
  code,
  code2Fa,
  setCode,
  setCode2Fa
}: TwoFASetupProps) => {
  const dispatch = useAppDispatch();
  const [loadingCode, setLoadingCode] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const { user } = useAppSelector((state) => state.auth.userInfo);

  const sendCode = async () => {
    try {
      setLoadingCode(true);
      if (!packageId) {
        await axios.post(`/explorer/bonus-nft-withdraw/email/code`, {
          walletAddress: walletAddress
        });
      } else {
        await axios.post(`/explorer/nft-withdraw/email/code`, {
          userPackageId: packageId,
          walletAddress: walletAddress
        });
      }

      SuccessToast('Code sent successfully');
      setLoadingCode(false);
      setIsCodeSent(true);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const onHandleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!packageId) {
      dispatch(
        confirmBonusHubgNFTWithdraw({
          walletAddress,
          walletAddressSign,
          emailCode: code,
          twoFACode: code2Fa,
          setWithdrawStep,
          setLoadingCode
        })
      );
    } else {
      dispatch(
        confirmNFTWithdraw({
          userPackageId: packageId,
          walletAddress,
          walletAddressSign,
          emailCode: code,
          twoFACode: code2Fa,
          setWithdrawStep,
          setLoadingCode
        })
      );
    }
  };

  return (
    <div style={{ marginTop: '20vh' }}>
      {loadingCode ? (
        <Spinner />
      ) : (
        <form onSubmit={onHandleSubmit}>
          <P1 bold center mb='30'>
            STEP 2: SECURITY VERIFICATION
          </P1>
          <Flexed between>
            <P2 bold color={color.colors.neutral700}>
              Email verification code
            </P2>
            <P2
              bold
              style={{ cursor: 'pointer' }}
              color={color.colors.primary900}
              onClick={() => sendCode()}>
              Send Code
            </P2>
          </Flexed>
          <SecurityCodeWrapper>
            <ReactCodeInput
              fields={7}
              value={code}
              onChange={setCode}
              type={'number'}
              name='phone code'
              inputMode='numeric'
            />
          </SecurityCodeWrapper>
          <P3 color={color.colors.neutral500} mb='40'>
            {isCodeSent && `Enter the 7 digit code sent to ${user?.email}`}
          </P3>

          <div>
            <Flexed between>
              <P2 bold color={color.colors.neutral700}>
                2FA verification code
              </P2>
            </Flexed>
            <SecurityCodeWrapper is2Fa>
              <ReactCodeInput
                fields={6}
                value={code2Fa}
                onChange={setCode2Fa}
                type={'number'}
                name='phone code2 '
                inputMode='numeric'
              />
            </SecurityCodeWrapper>
            <P3 color={color.colors.neutral500} mb='10'>
              Enter the 6 digit code from your 2FA authenticator
            </P3>
          </div>

          <Button m='30px 0 10px 0' disabled={code === '' ? true : false}>
            Confirm
          </Button>
        </form>
      )}
    </div>
  );
};
